import { GalleryState, GalleryStateItem } from '@/lib/types/store/gallery'
import { PayloadAction, createSlice } from '@reduxjs/toolkit'

const initialState: GalleryState = {
  items: [],
  loading: false,
  error: null,
  selectedItem: null,
  page: 1,
  limit: 12,
  total: 0
}

const gallerySlice = createSlice({
  name: 'gallery',
  initialState,
  reducers: {
    setGallery: (state, action: PayloadAction<GalleryStateItem[]>) => {
      state.items = action.payload
      state.loading = false
      state.error = null
    },
    updateGalleryItem: (state, action: PayloadAction<GalleryStateItem>) => {
      const index = state.items.findIndex(item => item.id === action.payload.id)
      if (index !== -1) {
        state.items[index] = action.payload
      } else {
        state.items.push(action.payload)
      }
      state.loading = false
      state.error = null
    },
    deleteGalleryItem: (state, action: PayloadAction<string>) => {
      state.items = state.items.filter(item => item.id !== action.payload)
      if (state.selectedItem?.id === action.payload) {
        state.selectedItem = null
      }
    },
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload
    },
    setError: (state, action: PayloadAction<string>) => {
      state.error = action.payload
      state.loading = false
    },
    setSelectedItem: (state, action: PayloadAction<GalleryStateItem | null>) => {
      state.selectedItem = action.payload
    },
    setPagination: (state, action: PayloadAction<{ page: number; limit: number; total: number }>) => {
      state.page = action.payload.page
      state.limit = action.payload.limit
      state.total = action.payload.total
    }
  },
})

export const {
  setGallery,
  updateGalleryItem,
  deleteGalleryItem,
  setLoading,
  setError,
  setSelectedItem,
  setPagination
} = gallerySlice.actions

export default gallerySlice.reducer
